import React, { useEffect } from "react";
import { Provider } from "react-redux";
import { cls } from "@wss/cls";
import Store from "~/common/Store";
import RestaurantBrands from "./RestaurantBrands";
import PlatinumRepAndFeaturesView from "./Platinum";
import FoodserviceResources from "./FoodserviceResources";
import NotificationBar from "./NotificationBar";
import HomePageAdBanner from "./Banner";
import RequestToQuote from "./RequestToQuote";
import PlusEssentialsAd from "~/common/Ads/PlusEssentialsAd";
import PlusFreeviewAd from "~/common/Ads/PlusFreeviewAd";
import { useHomePageData } from "./utilities";
import { CarouselSections } from "./Carousel/index";
import PlusAd from "./PlusAd";
import { FeaturedSection } from "./FeaturedSection";
import WaysToSave from "./WaysToSave";
import FeaturedCategories from "./FeaturedCategories";
import Advertisements from "./Advertisements";
import withFeatureFlags from "~/common/hocs/withFeatureFlags";
import { useFeatureFlag } from "~/common/contexts/FeatureFlagProvider";
import PersonalizedProductRecommendations from "./components/PersonalizedProductRecommendations";
import WebPlusAd from "~/features/plus/ads/WebPlusAd";
const HomePage = () => {
  const {
    header
  } = useHomePageData();
  const {
    evaluateFlag
  } = useFeatureFlag();
  useEffect(() => {
    document.body.classList.add("home");
  }, []);
  return <Provider store={Store} data-sentry-element="Provider" data-sentry-component="HomePage" data-sentry-source-file="index.tsx">
      <div data-module="initHomePage" className="wss">
        <NotificationBar data-sentry-element="NotificationBar" data-sentry-source-file="index.tsx" />
        <HomePageAdBanner data-sentry-element="HomePageAdBanner" data-sentry-source-file="index.tsx" />
        <PlusEssentialsAd pageType="Home" data-sentry-element="PlusEssentialsAd" data-sentry-source-file="index.tsx" />
        <PlusFreeviewAd containerProps={{
        className: cls("container", "pt-6")
      }} containerTestId="homepage-plus-freeview-container" gtmId="plus-freeview-homepage" freeviewInitialAdTestId="homepage-plus-freeview-initial-ad" freeviewFinalAdTestId="homepage-plus-freeview-final-ad" data-sentry-element="PlusFreeviewAd" data-sentry-source-file="index.tsx" />
        <h1 className="sr-only skip-to-main-target">{header}</h1>
        <div className="bg-white md:bg-transparent -mb-16">
          <PlatinumRepAndFeaturesView data-sentry-element="PlatinumRepAndFeaturesView" data-sentry-source-file="index.tsx" />

          <CarouselSections data-sentry-element="CarouselSections" data-sentry-source-file="index.tsx">
            <Advertisements data-sentry-element="Advertisements" data-sentry-source-file="index.tsx" />
            <div className="bg-white pt-6 xl:pt-10 pb-0">
              {evaluateFlag("personalized-product-recommendations") && <PersonalizedProductRecommendations className="container pb-6 xl:pb-10" />}
              {evaluateFlag("plus-ads-rewrite") ? <WebPlusAd /> : <PlusAd />}
              <FeaturedSection data-sentry-element="FeaturedSection" data-sentry-source-file="index.tsx" />
              <div id="customerio-section1" />
              <div id="customerio-section2" />
              <WaysToSave data-sentry-element="WaysToSave" data-sentry-source-file="index.tsx" />
              <FeaturedCategories data-sentry-element="FeaturedCategories" data-sentry-source-file="index.tsx" />
            </div>
          </CarouselSections>
          <div className="bg-white">
            <RequestToQuote data-sentry-element="RequestToQuote" data-sentry-source-file="index.tsx" />
            <RestaurantBrands data-sentry-element="RestaurantBrands" data-sentry-source-file="index.tsx" />
            <FoodserviceResources data-sentry-element="FoodserviceResources" data-sentry-source-file="index.tsx" />
          </div>
        </div>
      </div>
    </Provider>;
};
export default withFeatureFlags(HomePage);